import type { CreateOrderAmendmentRequest, Order } from "../../services/ordersApi";

type StructuredTransportFields = Pick<
  CreateOrderAmendmentRequest,
  | "transportMode"
  | "manualTransportCost"
  | "expectedDeliveryDate"
  | "deliveryContactPerson"
  | "deliveryContactPhone"
>;

const toDateInputValue = (value?: string | null) => {
  if (!value) return "";
  const parsed = new Date(value);
  return Number.isNaN(parsed.getTime()) ? "" : parsed.toISOString().slice(0, 10);
};

const changedText = (value: string, original?: string | null) =>
  value.trim() !== (original ?? "").trim();

export const buildStructuredTransportAmendmentFields = (
  order: Order,
  customerPickup: boolean,
  manualTransportCost: string,
  expectedDeliveryDate: string,
  deliveryContactPerson: string,
  deliveryContactPhone: string,
): StructuredTransportFields => {
  if (customerPickup && order.fulfilmentMethod === "Delivery") {
    return {
      transportMode: "Pickup",
      manualTransportCost: undefined,
      expectedDeliveryDate: undefined,
      deliveryContactPerson: undefined,
      deliveryContactPhone: undefined,
    };
  }
  const revisedTransportCost = Math.max(0, Number(manualTransportCost) || 0);
  const feeChanged = revisedTransportCost !== Number(order.transportCost ?? 0);

  return {
    transportMode: feeChanged ? "Manual" : "Keep",
    manualTransportCost: feeChanged ? revisedTransportCost : undefined,
    expectedDeliveryDate: expectedDeliveryDate !== toDateInputValue(order.expectedDeliveryDate)
      ? expectedDeliveryDate || null
      : undefined,
    deliveryContactPerson: changedText(deliveryContactPerson, order.deliveryContactPerson)
      ? deliveryContactPerson.trim() || null
      : undefined,
    deliveryContactPhone: changedText(deliveryContactPhone, order.deliveryContactPhone)
      ? deliveryContactPhone.trim() || null
      : undefined,
  };
};
